import { createAction, props } from '@ngrx/store';
import { Event } from '@app/state/models';

export const eventCreate = createAction(
  '[Calendar] Create Event',
  props<{ event: Event }>()
);

export const eventCreateSuccess = createAction(
  '[Calendar API] Create Event Success',
  props<{ event: Event }>()
);

export const eventCreateFailure = createAction(
  '[Calendar API] Create Event Failure',
  props<{ error: any }>()
);

export const eventGet = createAction(
  '[Calendar] Get Event',
  props<{ id: string }>()
);

export const eventGetSuccess = createAction(
  '[Calendar API] Get Event Success',
  props<{ event: Event }>()
);

export const eventGetFailure = createAction(
  '[Calendar API] Get Event Failure',
  props<{ error: any }>()
);

export const eventGetAll = createAction(
  '[Calendar] Get All Events'
);

export const eventGetAllSuccess = createAction(
  '[Calendar API] Get All Events Success',
  props<{ events: Event[] }>()
);

export const eventGetAllFailure = createAction(
  '[Calendar API] Get All Events Failure',
  props<{ error: any }>()
);

export const eventUpdate = createAction(
  '[Calendar] Update Event',
  props<{ event: Event }>()
);

export const eventUpdateSuccess = createAction(
  '[Calendar API] Update Event Success',
  props<{ event: Event }>()
);

export const eventUpdateFailure = createAction(
  '[Calendar API] Update Event Failure',
  props<{ error: any }>()
);

export const eventDelete = createAction(
  '[Calendar] Delete Event',
  props<{ id: string }>()
);

export const eventDeleteSuccess = createAction(
  '[Calendar API] Delete Event Success'
);

export const eventDeleteFailure = createAction(
  '[Calendar API] Delete Event Failure',
  props<{ error: any }>()
);